export const BET_RESULTS = {
    PENDING : 0,
    NONE : 1,
    EVEN : 2,
    ODD : 3,
    REIMBURSED : 4
}

export const BET_RESULTS_STRING = ["PENDING", "NONE", "EVEN", "ODD", "REIMBURSED"];